import React from "react";

/**
 * StatusTag — quiet pill, never neon. Inherits VÉRAULT palette.
 */
const TONES = {
  neutral:
    "bg-[hsl(var(--background-stone))]/60 text-[hsl(var(--foreground-secondary))] border-[rgba(0,0,0,0.06)]",
  gold:
    "bg-[hsl(var(--accent-gold))]/12 text-[hsl(var(--accent-gold))] border-[hsl(var(--accent-gold))]/25",
  sage:
    "bg-[hsl(var(--accent-sage))]/14 text-[hsl(var(--accent-sage))] border-[hsl(var(--accent-sage))]/30",
  terracotta:
    "bg-[hsl(var(--accent-terracotta))]/12 text-[hsl(var(--accent-terracotta))] border-[hsl(var(--accent-terracotta))]/25",
  charcoal:
    "bg-[hsl(var(--accent-charcoal))]/8 text-[hsl(var(--accent-charcoal))] border-[hsl(var(--accent-charcoal))]/15",
};

export function StatusTag({ tone = "neutral", children, className = "", testid, "data-testid": dataTestId }) {
  return (
    <span
      data-testid={testid || dataTestId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-[0.18em] ${
        TONES[tone] || TONES.neutral
      } ${className}`}
    >
      <span className="size-1.5 rounded-full bg-current opacity-70" aria-hidden />
      {children}
    </span>
  );
}
